/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module easy-image
 */

export { default as EasyImage } from './easyimage';
export { default as CloudServicesUploadAdapter } from './cloudservicesuploadadapter';
